import React, { FC } from 'react'
import { useHideModal } from '@libs/components'
import { Modal, Typography } from 'antd'
import { Close24 } from '@carbon/icons-react'
import { useLocalization } from '@libs/localization'

export interface TextTaskNotesModalProps {
	notes?: string
}

const TextTaskNotesModal: FC<TextTaskNotesModalProps> = ({ notes }) => {
	const hideModal = useHideModal()
	const { t } = useLocalization()

	return (
		<Modal
			closeIcon={<Close24 />}
			visible
			width={640}
			title={t('modals.textTaskNotes.title')}
			onCancel={hideModal}
			footer={null}
		>
			{notes ? (
				<Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>{notes}</Typography.Paragraph>
			) : (
				<Typography.Text>{t('modals.textTaskNotes.notesNotProvided')}</Typography.Text>
			)}
		</Modal>
	)
}

export default TextTaskNotesModal
